import React from 'react';

// Do not download every video in a carousel before the user can see it.
export default class VisibleVideo extends React.Component {
    constructor(props) {
        super(props);
        this.video = React.createRef();
        this.state = {loaded: false};
        this.visible = false;
    }
    componentDidMount() {
        this.alive = true;
        if (typeof IntersectionObserver === 'undefined') {
            this.visible = true;
            this.updatePlayback();
        } else {
            this.observer = new IntersectionObserver(entries => {
                this.visible = entries.some(entry => entry.isIntersecting);
                this.updatePlayback();
            }, {rootMargin: '100px'});
            this.observer.observe(this.video.current);
        }
        document.addEventListener('visibilitychange', this.updatePlayback);
    }
    componentWillUnmount() {
        this.alive = false;
        if (this.observer) this.observer.disconnect();
        document.removeEventListener('visibilitychange', this.updatePlayback);
        if (this.video.current) this.video.current.pause();
    }
    updatePlayback = () => {
        if (!this.alive || !this.video.current) return;
        if (!this.visible || document.visibilityState === 'hidden') {
            this.video.current.pause();
        } else if (!this.state.loaded) {
            this.setState({loaded: true}, this.updatePlayback);
        } else {
            const playing = this.video.current.play();
            if (playing && playing.catch) playing.catch(() => {});
        }
    };
    render() {
        return <video ref={this.video} poster={this.props.poster} style={this.props.style}
            src={this.state.loaded ? this.props.src : undefined}
            autoPlay playsInline webkit-playsinline="true" loop preload="metadata" muted/>;
    }
}
